import { RenderViewSdgAlignmentsParams } from '@upright/common/renderer/component-types/types-render-view-sdg-alignments';
import { useGetModelEntityScoreData } from '@upright/ui/api/model/output/scores/model-entity-data/use-get-model-entity-score-data';
import { SdgAlignments } from '@upright/ui/common/upright/model/output/scores/sdg-alignments';
import { useSdgAlignmentsContextBuilder } from '@upright/ui/common/upright/model/output/scores/sdg-alignments/context';
import styled from 'styled-components';
import { useRenderViewContext } from '../../context';
import { RenderViewTitleMaybe } from '../shared/render-view-title-maybe';
import { getRenderViewSdgDefaultTitle } from './get-render-view-sdg-default-title';

export const RenderViewSdgAlignments = (props: { params: RenderViewSdgAlignmentsParams }) => {
  const { params } = props;
  const { item } = params;
  const context = useRenderViewContext();

  const release = context.options.release;

  const modelEntityReference = { id: item.id, type: item.type };
  const query = useGetModelEntityScoreData({
    modelEntityReference,
    overrides: { releaseOrVersion: release },
  });
  const entity = query.data;

  const sdgContext = useSdgAlignmentsContextBuilder({
    entityId: item.id,
    entityType: item.type,
    entity,
    resultId: item.resultId,
    viewOptions: {
      unitsMode: params.unitsMode,
      layout: params.layout,
      sdgIdsToShow: params.sdgIdsToShow,
      disableInteraction: true,
      hideLegendBorders: true,
      showModelVersionText: true,
      showBottomBorder: true,
      hideInfoBox: true,
      hideRenderViewButton: true,
    },
  });

  return (
    <Root style={{ width: context.options.width }}>
      <RenderViewTitleMaybe params={params} defaultTitle={getRenderViewSdgDefaultTitle(params)} />
      <SdgAlignments context={sdgContext} />
    </Root>
  );
};

const Root = styled.div``;
